import CryptoJS from 'crypto-js';

/**
 *  Generates a random IV (Initialization Vector) for AES encryption.
 * @returns WordArray
 */
export const generateRandomIV = () => {
  return CryptoJS.lib.WordArray.random(16);
};

/**
 * Encrypts the given plain text using AES encryption with the given key and IV.
 * @param plainText string
 * @param key string
 * @param iv WordArray
 * @returns string
 */
export const encrypt = (plainText: string, key: string, iv) => {
  // Convert the key to a WordArray
  const keyWordArray = CryptoJS.enc.Utf8.parse(key);

  // Encrypt using AES CBC mode with PKCS7 padding
  const encrypted = CryptoJS.AES.encrypt(plainText, keyWordArray, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Concatenate the IV and the encrypted data
  const encryptedData = iv
    .concat(encrypted.ciphertext)
    .toString(CryptoJS.enc.Base64);

  return encryptedData;
};
